module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Text-06ab76a5969bbe8e104eb27ecda7956a.svg";